<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-if="showBtn!=2">
        <el-button size="mini" type="primary" @click="showAddOrder()">下单</el-button>
      </el-breadcrumb-item> -->
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="">
        <el-button size="mini" type="primary" @click="exportOrder">导出数据</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部订单" name=""></el-tab-pane>
      <!-- <el-tab-pane label="询价" name="enquiry"></el-tab-pane> -->
      <el-tab-pane label="未接单" name="noOrder"></el-tab-pane>
      <el-tab-pane label="已接单" name="ReceiveOrder"></el-tab-pane>
      <!-- <el-tab-pane label="分批发货" name="partialShipment"></el-tab-pane> -->
      <el-tab-pane label="已发货" name="shipped"></el-tab-pane>
      <el-tab-pane label="已完成" name="finish"></el-tab-pane>
    </el-tabs>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="sreachData.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setWeek">最近一周</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setMonth">最近一个月</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setThreeMonth">最近三个月</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="价格">
        <el-input v-model="sreachData.minMoney"></el-input>
        <!-- <el-input-number v-model="sreachData.minMoney" controls-position="right" :precision="2" :step="0.1" :min="0"></el-input-number> -->
      </el-form-item>
      <span style="line-height:40px;margin:0 10px">-</span>
      <el-form-item label="">
        <el-input v-model="sreachData.maxMoney"></el-input>
        <!-- <el-input-number v-model="sreachData.maxMoney" controls-position="right" :precision="2" :step="0.1" :min="sreachData.minMoney"></el-input-number> -->
      </el-form-item>
      <el-form-item label="数量">
        <el-input-number v-model="sreachData.num" controls-position="right" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="需求来源" v-if="showBtn==3||showBtn<1||showBtn==2">
        <el-select v-model="sreachData.company" filterable clearable placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(val, key) in company" :key="key" :label="val.company" :value="val.id">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" v-if="showBtn==3||showBtn<1||showBtn==5">
        <el-select v-model="sreachData.supplier" filterable clearable placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(val, key) in supplier" :key="key" :label="val.company" :value="val.companyid">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="状态">
        <el-select v-model="sreachData.status" placeholder="订单状态">
          <el-option label="全部状态" value="">全部状态</el-option>
          <!-- <el-option label="询价" value="enquiry">询价</el-option> -->
          <el-option label="未接单" value="noOrder">未接单</el-option>
          <el-option label="已接单" value="ReceiveOrder">已接单</el-option>
          <!-- <el-option label="分批发货" value="partialShipment">分批发货</el-option> -->
          <el-option label="已发货" value="shipped">已发货</el-option>
          <el-option label="完成" value="finish">完成</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="po单">
        <el-input v-model="sreachData.pos" placeholder="po单" style="width:300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="关键词">
        <el-input v-model="sreachData.words" placeholder="订单行号|编码|名称|描述/规格|单位|备注" style="width:300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="searchOrder">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      tooltip-effect="dark"
      border
      :data="tableData"
      style="width: 100%"
      row-key="id"
      default-expand-all
      :tree-props="{children: 'supplierlist'}"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="45"
        disabled>
      </el-table-column>
      <el-table-column
        prop="id"
        width="80"
        label="ID">
      </el-table-column>
      <!-- <el-table-column
        prop="sn"
        width="140"
        label="订单行号">
      </el-table-column> -->
      <el-table-column
        prop="posn"
        width="160"
        label="po单号">
      </el-table-column>
      <el-table-column
        prop="gcode"
        width="100"
        label="物料编号">
      </el-table-column>
      <el-table-column
        prop="title"
        label="物料名称">
      </el-table-column>
      <el-table-column
        prop="remark"
        width="200"
        label="物料描述/规格">
        <template slot-scope="scope">
          <p class="slh" :title="scope.row.remark">{{scope.row.remark}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="unit"
        width="50"
        label="单位">
      </el-table-column>
      <el-table-column
        prop="price"
        width="110"
        label="单价（含税）">
        <template slot-scope="scope">
          <p v-if="scope.row.gprice!=scope.row.price" style="color:red">{{scope.row.price}}</p>
          <p v-else>{{scope.row.price}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="num"
        width="50"
        label="数量">
      </el-table-column>
      <el-table-column
        prop="total"
        width="110"
        label="总价">
      </el-table-column>
      <el-table-column
        prop="costNum"
        label="发货数量"
        width="80">
      </el-table-column>
      <el-table-column
        prop="deliveryTime"
        width="120"
        label="要求到货时间">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="140"
        label="下单时间">
      </el-table-column>
      <el-table-column
        prop="send_start_time"
        width="140"
        label="发货时间">
      </el-table-column>
      <el-table-column
        prop="company"
        width="110"
        label="需求来源">
      </el-table-column>
      <el-table-column
        prop="supplierCompany"
        width="110"
        label="供应商">
      </el-table-column>
      <el-table-column
        prop="orderRemark"
        width="200"
        label="备注">
      </el-table-column>
      <el-table-column
        prop="statusName"
        width="100"
        label="状态">
      </el-table-column>
      <el-table-column
        label="操作"
        width="220">
        <template slot-scope="scope">
          <!-- <el-button style="margin-bottom:5px;" v-show="(showBtn==0||showBtn==3||showBtn==2)&&scope.row.status>1" size="mini" type="primary" plain @click="downPO(scope.row.id)">po单</el-button> -->
          <el-button v-show="scope.row.file" size="mini" type="info" plain @click="downfile(scope.row.file)">下载文件</el-button>
          <el-button v-show="(scope.row.status==3||scope.row.status==4)&&(scope.row.costNum>scope.row.reviceNum+scope.row.noNum)&&showBtn==5" size="mini" type="primary" plain @click="showFinish(scope.row.id)">收货</el-button>
          <!-- <el-button v-show="(scope.row.sendType==2&&scope.row.pid||scope.row.sendType==1)&&scope.row.status=='询价'&&showBtn==0" size="mini" type="primary" plain @click="examineOrder(scope.row.id)">过审</el-button> -->
          <!-- <el-button v-show="((scope.row.sendType==2&&scope.row.pid)||scope.row.sendType==1)&&scope.row.status==1&&showBtn==2" size="mini" type="primary" plain @click="ReceiveOrder(scope.row.id)">接单</el-button> -->
          <el-button v-show="((scope.row.sendType==2&&scope.row.pid)||scope.row.sendType==1)&&(scope.row.status==2||scope.row.status==4)&&showBtn==2" size="mini" type="primary" plain @click="showSend(scope.row.id)">发货</el-button>
          <el-button v-show="((scope.row.sendType==2&&scope.row.pid)||scope.row.sendType==1)&&(scope.row.status==2||scope.row.status==4)&&(showBtn<1||showBtn==3)&&!scope.row.sendFinish" size="mini" type="primary" plain @click="showFinishSend(scope.row.id)">结束发货</el-button>
          <el-button v-show="!scope.row.pid||showBtn==2" size="mini" type="success" plain @click="editOrder(scope.row.id)">详情</el-button>
          <el-button v-show="scope.row.status==5&&showBtn==5" size="mini" plain @click="showService(scope.row.id)">申请售后</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delOrders(scope.row.id)" 
            title="确定删除订单吗？"
          >
            <el-button v-if="!scope.row.pid&&(showBtn==0||(scope.row.status==1&&showBtn==1))" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <p>
      <span style="float:left">
        <el-button v-show="showBtn==2" @click="downPOAll()">接单并创建po</el-button>
        <el-button v-show="showBtn==2||showBtn==0" type="primary" @click="showSendAll()">批量发货</el-button>
        <el-button v-show="showBtn==5" @click="finishAll()">批量收货</el-button>
      </span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
  <el-dialog title="结束发货" label-position="left" :visible.sync="sendFinishBox" width="70%">
    <el-form ref="form" :model="form" label-width="140px">
      <el-form-item label="备注">
        <el-input type="textarea" v-model="sendFinishForm.remark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="orderBox = false">取 消</el-button>
      <el-button type="primary" @click="sendFinish">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="下单" label-position="left" :visible.sync="orderBox" width="70%">
    <el-form ref="form" :model="form" label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物料编号" :required="true">
            <el-input v-model="form.gcode" @change="getGoods()" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户物料编码">
            <el-input v-model="form.cgcode" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="物料名称">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form :model="form" inline label-width="140px">
        <el-form-item label="单价（含税）">
          <el-input-number v-model="form.price" :precision="4" :step="0.1" :min="0.10" :max="999999999"></el-input-number>
        </el-form-item>
        <el-form-item label="单位" :required="true">
          <el-input v-model="form.unit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="申请数量" :required="true">
          <el-input-number v-model="form.num" :precision="2" :min="1" :max="999999999"></el-input-number>
        </el-form-item>
      </el-form>
      <el-form-item label="要求到货时间">
        <el-input v-model="form.deliveryTime" maxlength="60" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="物料描述/规格">
        <el-input type="textarea" v-model="form.remark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工厂" :required="true">
            <el-input v-model="form.factory" autocomplete="off" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="采购员">
            <el-input v-model="form.purchase" autocomplete="off" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="库位" :required="true">
        <el-input type="textarea" v-model="form.locator" maxlength="150" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="审核状态" v-if="showBtn==0">
        <el-radio-group v-model="form.examine">
          <el-radio :label="0">待审核</el-radio>
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="2">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核原因" v-if="showBtn==0&&form.examine==2">
        <el-input type="textarea" v-model="form.examineMsg" maxlength="250" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.orderRemark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="orderBox = false">取 消</el-button>
      <el-button type="primary" @click="createOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="批量发货" label-position="left" :visible.sync="sendAllBox" width="70%">
    <el-form ref="form" :model="form" label-width="140px">
      <!-- <el-form-item label="发货方式" :required="true">
        <el-radio-group v-model="sendForm.sendType">
          <el-radio :label="0">一次性发货</el-radio>
          <el-radio :label="1">分批发货</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="物流公司" :required="true">
        <el-input v-model="sendForm.expressCompany" autocomplete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="送货数量" :required="true">
        <el-input-number v-model="sendForm.expressNum" :min="1" :max="expressNum"></el-input-number>
      </el-form-item> -->
      <el-form-item label="送货单号" :required="true">
        <el-input v-model="sendForm.expressSn" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="sendForm.expressRemark" maxlength="150" show-word-limit autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="sendAllBox = false">取 消</el-button>
      <el-button type="primary" @click="sendAllOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="发货" label-position="left" :visible.sync="sendBox" width="70%">
    <el-form ref="form" :model="form" label-width="140px">
      <!-- <el-form-item label="发货方式" :required="true">
        <el-radio-group v-model="sendForm.sendType">
          <el-radio :label="0">一次性发货</el-radio>
          <el-radio :label="1">分批发货</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="物流公司" :required="true">
        <el-input v-model="sendForm.expressCompany" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="送货数量" :required="true">
        <el-input-number v-model="sendForm.expressNum" :min="1" :max="expressNum"></el-input-number>
      </el-form-item>
      <el-form-item label="送货单号" :required="true">
        <el-input v-model="sendForm.expressSn" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="sendForm.expressRemark" maxlength="150" show-word-limit autocomplete="off"></el-input>
      </el-form-item>
      <el-row>
        <el-divider content-position="left">发货记录</el-divider>
        <el-table
          :data="log"
          style="width: 100%">
          <el-table-column
            prop="company"
            label="发货公司">
          </el-table-column>
          <el-table-column
            prop="num"
            label="发货数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="sn"
            label="发货单号">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="时间">
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="sendBox = false">取 消</el-button>
      <el-button type="primary" @click="sendOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="收货" label-position="left" :visible.sync="finishBox" width="70%">
    <el-form ref="form" label-width="140px">
      <el-table
        :data="log"
        style="width: 100%">
        <el-table-column
          prop="company"
          label="发货公司">
        </el-table-column>
        <el-table-column
          prop="num"
          label="发货数量"
          width="120">
        </el-table-column>
        <el-table-column
          prop="sn"
          label="发货单号">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <!-- <el-table-column
          label="收货数量">
          <template slot-scope="scope">
            <p v-if="scope.row.reviceTime">{{scope.row.reviceNum}}</p>
            <el-input-number size="mini" v-else v-model="scope.row.reviceNum" :min="0" :max="parseInt(scope.row.num) - parseInt(scope.row.noNum)"></el-input-number>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="退换数量">
          <template slot-scope="scope">
            <p v-if="scope.row.reviceTime">{{scope.row.noNum}}</p>
            <el-input-number size="mini" v-else v-model="scope.row.noNum" :min="0" :max="parseInt(scope.row.num) - parseInt(scope.row.reviceNum)"></el-input-number>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="发货时间">
        </el-table-column>
        <el-table-column
          prop="reviceTime"
          label="收货时间">
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="finishBox = false">取 消</el-button>
      <el-button type="primary" @click="finishOrder">确认收货</el-button>
    </div>
  </el-dialog>
  <el-dialog title="申请售后" label-position="left" :visible.sync="serviceBox" width="70%">
    <el-form ref="form" label-width="140px">
      <p>发货数量：{{serviceForm.num}}；收货数量：{{serviceForm.num - serviceForm.noNum}}；拒收数量：{{serviceForm.noNum}}；</p>
      <el-form-item label="发货方式" :required="true">
        <el-radio-group v-model="serviceForm.type">
          <el-radio :label="1">退货</el-radio>
          <el-radio :label="2">换货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="货物数量" :required="true">
        <el-input-number v-model="serviceForm.noNum" :min="1" :precision="2" :max="serviceForm.num"></el-input-number>
      </el-form-item>
      <el-form-item label="联系人" :required="true">
        <el-input v-model="serviceForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" :required="true">
        <el-input v-model="serviceForm.phone" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="原因" :required="true">
        <el-input v-model="serviceForm.remark" autocomplete="off" type="textarea" :rows="2"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="serviceBox = false">取 消</el-button>
      <el-button type="primary" @click="serviceOrder">确 定</el-button>
    </div>
  </el-dialog>
</el-card>
</template>
<script>
import userFunction from "@/api/user"
import orderFunction from "@/api/order"
import goodsFunction from "@/api/goods"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      sendBox:false,
      sendAllBox:false,
      finishBox:false,
      serviceBox:false,
      sendFinishBox:false,
      total:0,
      orderBox:false,
      tableLoading:false,
      activeName:"",
      level:[],
      Selectionids:[],
      log:[],
      supplier:[],
      company:[],
      expressNum:0,
      sreachData:{
        createTime:[],
        num:'',
        limit:10,
        page:1,
        supplier:'',
        minMoney:'',
        maxMoney:'',
        company:'',
        status:'',
        words:'',
        pos:'',
        vcode:sessionStorage.getItem('token'),
      },
      tableData:[],
      sendFinishForm:{
        id:'',
        remark:'',
        vcode:sessionStorage.getItem('token'),
      },
      sendForm:{
        id:'',
        sendType:0,
        expressCompany:'',
        expressNum:0,
        expressSn:'',
        expressRemark:'',
        vcode:sessionStorage.getItem('token'),
      },
      serviceForm:{
        id:'',
        type:1,
        noNum:0,
        num:0,
        reviceNum:0,
        name:'',
        phone:'',
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      form:{
        gcode:'',
        cgcode:'',
        title:'',
        unit:'',
        price:'',
        remark:'',
        deliveryTime:'',
        factory:'',
        purchase:'',
        locator:'',
        num:'',
        orderRemark:'',
        examine:0,
        examineMsg:'',
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    downPOAll(){
      var Data = this.Selectionids
      if(Data.length<1){
        this.$message.error('请勾选需要形成po单的订单')
        return false
      }
      orderFunction.downPOAll({id:Data,vcode:sessionStorage.getItem('token')},this).then(res=>{
        let a = document.createElement('a')
        a.target = '_blank'
        a.href = res.file
        a.click()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    finishAll(){
      var Data = this.Selectionids
      if(Data.length<1){
        this.$message.error('请勾选需要收货的订单')
        return false
      }
      orderFunction.finishAll({id:Data,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showAddOrder(){
      this.orderBox = true
      this.form.gcode = ''
      this.form.cgcode = ''
      this.form.title = ''
      this.form.unit = ''
      this.form.remark = ''
      this.form.deliveryTime = ''
      this.form.price = 0.00
      this.form.num = ''
      this.form.orderRemark = ''
      this.form.examine = 0
      this.form.examineMsg = ''
      this.form.factory = sessionStorage.getItem('company') ? sessionStorage.getItem('company') :''
      this.form.purchase = sessionStorage.getItem('contacts') ? sessionStorage.getItem('contacts') :''
      this.form.locator = sessionStorage.getItem('address') ? sessionStorage.getItem('address') :''
    },
    setWeek(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.sreachData.createTime = [start,end]
    },
    setMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.sreachData.createTime = [start,end]
    },
    setThreeMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.sreachData.createTime = [start,end]
    },
    handleSizeChange(val){
      this.sreachData.limit = val
      this.getList()
    },
    handleCurrentChange(val){
      this.sreachData.page = val
      this.getList()
    },
    getList(){
      orderFunction.list(this.sreachData,this).then(res=>{
        this.tableData = res.data
        this.total = res.total
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    downfile(file){
      let a = document.createElement('a')
        a.href = file
        a.click()
    },
    createOrder(){
      if(!this.form.gcode){
        this.$message.error('物料编号不能为空');
        return false;
      }
      if(!this.form.unit){
        this.$message.error('单位不能为空');
        return false;
      }
      if(!this.form.num){
        this.$message.error('申请数量不能为空');
        return false;
      }
      if(!this.form.factory){
        this.$message.error('工厂不能为空');
        return false;
      }
      if(!this.form.locator){
        this.$message.error('库位不能为空');
        return false;
      }
      orderFunction.save(this.form,this).then(res=>{
        this.orderBox = false
        this.form.gcode = ''
        this.form.cgcode = ''
        this.form.title = ''
        this.form.unit = ''
        this.form.remark = ''
        this.form.deliveryTime = ''
        this.form.price = 0.00
        this.form.num = ''
        this.form.orderRemark = ''
        this.form.examine = 0
        this.form.examineMsg = ''
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    editOrder(id){
      this.$router.push({path: '/home/editOrder',query: {id: id}})
    },
    delOrders(id){
      var delData = [];
      if(id){
        delData.push(id)
      }else{
        delData = this.Selectionids
      }
      orderFunction.del({id:delData,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    searchOrder(){
      this.tableData = []
      this.getList()
    },
    handleClick(){
      this.sreachData.status = this.activeName;
      this.getList()
    },
    handleSelectionChange(val) {
      this.Selectionids = []
      for(var i in val){
        this.Selectionids.push(val[i].id);
      }
      
    },
    getGoods(){
      goodsFunction.getGoods({gcode:this.form.gcode,cgcode:this.form.cgcode,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.form.gcode = res.gcode
        this.form.cgcode = res.cgcode
        this.form.title = res.title
        this.form.unit = res.unit
        this.form.remark = res.remark
        this.form.price = res.price
        this.form.unit = res.unit
        this.form.unit = res.unit
        var oDate = new Date();
        var oDate1 = new Date(res.validity_start_time);
        var oDate2 = new Date(res.validity_end_time);
        if(oDate1.getTime() > oDate.getTime()||oDate2.getTime() < oDate.getTime()){
          this.priceMsg=true;
        }else{
          this.priceMsg=false;
        }
        if(res.status!=1||res.examine!=1){
          this.$message.error('该物料已下架');
          return false;
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    ReceiveOrder(id){
      orderFunction.receive({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    examineOrder(id){
      orderFunction.examine({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showFinish(id){
      this.finishBox = true
      orderFunction.get({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.log = res.log
      })
    },
    showFinishSend(id){
      this.sendFinishBox = true
      this.sendFinishForm.id = id
      this.sendFinishForm.remark=''
    },
    sendFinish(){
      orderFunction.sendFinish(this.sendFinishForm,this).then(res=>{
        this.sendFinishBox = false
        this.getList()
      })
    },
    showSend(id){
      this.sendBox = true
      this.sendForm.id = id
      this.sendForm.sendType=0,
      this.sendForm.expressCompany=''
      this.sendForm.expressNum=0
      this.expressNum=0
      this.sendForm.expressSn=''
      this.sendForm.expressRemark=''
      orderFunction.get({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.log = res.log
        this.expressNum = res.num
        this.sendForm.expressNum = res.num - res.costNum
      })
    },
    showSendAll(){
      var Data = this.Selectionids
      if(Data.length<1){
        this.$message.error('请勾选需要发货的订单')
        return false
      }
      this.sendAllBox = true
      this.sendForm.sendType=0,
      this.sendForm.expressCompany=''
      this.sendForm.expressNum=0
      this.expressNum=0
      this.sendForm.expressSn=''
      this.sendForm.expressRemark=''
    },
    sendAllOrder(){
      var Data = this.Selectionids
      if(Data.length<1){
        this.$message.error('请勾选需要发货的订单')
        return false
      }
      if(!this.sendForm.expressCompany){
        this.$message.error('物流公司不能为空');
        return false;
      }
      if(!this.sendForm.expressSn){
        this.$message.error('送货单号不能为空');
        return false;
      }
      orderFunction.sendAll({
        ids:this.Selectionids,
        sendType:this.sendForm.sendType,
        expressCompany:this.sendForm.expressCompany,
        expressNum:this.sendForm.expressNum,
        expressSn:this.sendForm.expressSn,
        expressRemark:this.sendForm.expressRemark,
        vcode:sessionStorage.getItem('token'),
      },this).then(res=>{
        this.sendAllBox=false
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showService(id){
      this.serviceBox = true
      orderFunction.get({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.serviceForm.id = id
        this.serviceForm.num = res.num
        this.serviceForm.noNum = res.noNum
        this.serviceForm.reviceNum = res.reviceNum
      })
    },
    downPO(id){
      orderFunction.downPO({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        let a = document.createElement('a')
        a.target = '_blank'
        a.href = res.file
        a.click()
      })
    },
    sendOrder(){
      if(!this.sendForm.expressCompany){
        this.$message.error('物流公司不能为空');
        return false;
      }
      if(!this.sendForm.expressSn){
        this.$message.error('送货单号不能为空');
        return false;
      }
      orderFunction.send(this.sendForm,this).then(res=>{
        this.sendBox=false
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    finishOrder(){
      orderFunction.finish({data:this.log,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.finishBox=false
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    serviceOrder(){
      if(this.serviceForm.noNum<1){
        this.$message.error('请填写合适货物数量')
        return
      }
      if(this.serviceForm.name==''){
        this.$message.error('请填写联系人')
        return
      }
      if(this.serviceForm.phone==''){
        this.$message.error('请填写联系电话')
        return
      }
      if(this.serviceForm.remark==''){
        this.$message.error('请填写原因')
        return
      }
      orderFunction.service(this.serviceForm,this).then(res=>{
        this.serviceBox=false
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    getCompany(){
      userFunction.getCompany({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.company = res
      })
    },
    getSupplier(){
      userFunction.getSupplier({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
      })
    },
    exportOrder(){
        orderFunction.exportOrder(this.sreachData,this).then(res=>{
          let a = document.createElement('a')
          a.href = res.filepath
          a.click()
        })
      },
  },
  mounted () {
    this.getList()
    if(this.showBtn<1||this.showBtn==3||this.showBtn==5){
      this.getSupplier()
    }
    if(this.showBtn<1||this.showBtn==3||this.showBtn==2){
      this.getCompany()
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/order/orderslist.vue